import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ReporteData } from '../../models';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReporteriaService {
  private ENDPOINT = environment.ENDPOINTS.BOLETO;
  private ENDPOINTACTASPDF = environment.ENDPOINTS.ACTASPDF;
  private POINT_ROL_USER = environment.ENDPOINTS.TIPOROL;
  private REPORTES = environment.ENDPOINTS.API + "/reportesApi";
  constructor(private http: HttpClient) { }


  getBoletos() {
    return this.http.get<any[]>(`${this.ENDPOINT}`);
  }

  getTurnosActivos() {
    return this.http.get<any[]>(`${this.ENDPOINT}/turno/activo`);
  }

  getTurnos() {
    return this.http.get<any[]>(`${this.ENDPOINT}/turno/activo`).toPromise();
  }

  getCarriles(id_caseta) {
    return this.http.get<any[]>(`${this.ENDPOINT}/carriles/${id_caseta}`).toPromise();
  }

  getCobradores() {
    return this.http.get<any[]>(`${this.ENDPOINT}/reporte/cobradores`).toPromise();
  }

  getDataReporte(page: number, formData) {
    let param = new HttpParams;
    param = param.append('page', String(page));
    return this.http.post<ReporteData>(`${this.ENDPOINT}/reportes/getData`, formData, { params: param });
  }

  getDataActaPDF(page: number, formData) {
    let param = new HttpParams;
    param = param.append('page', String(page));
    return this.http.post<ReporteData>(`${this.ENDPOINT}/reportes/actasPDF`, formData, { params: param }).toPromise();
  }
  downloadFile(fileName: string) {
    return this.http.get(`${this.ENDPOINT}/download/actasPDF/${fileName}`, { responseType: 'blob' }).toPromise();
  }

  //EXPORTAR ARCHIVO
  descargarArchivo(formData) {
    return this.http.post(`${this.ENDPOINT}/reportes/downloadReporteConvenio`, formData, { responseType: 'blob' }).toPromise();
  }

  downloadExcel(file: Blob, nameFile) {
    const url = URL.createObjectURL(file);
    const link = document.createElement('a');
    link.href = url;
    link.download = nameFile;
    link.click();
    return url;
  }

  //ACTAS (ADMINISTRATIVAS / GXE)
  getPreviewActa(tipoActa, formData) {
    const { download } = formData;
    if (download) {
      const httpOptions = { responseType: 'blob' as 'json' };
      return this.http.post(`${this.ENDPOINTACTASPDF}/${tipoActa}`, formData, httpOptions).toPromise();
    }
    console.log("entro", download);
    return this.http.post(`${this.ENDPOINTACTASPDF}/${tipoActa}`, formData, { responseType: 'text' }).toPromise();
  }

  getUsersTipo(tipoUsuario) {
    return this.http.get<any[]>(`${this.POINT_ROL_USER}/${tipoUsuario}`).toPromise();
  }

  reportesEludidos(data) {
    return this.http.post(`${this.REPORTES}/eludidos/${data.tipo}`, data, {
      responseType: 'blob'
    });
  }

  example() {
    return this.http.get(`${this.REPORTES}/plantilla`, {
      responseType: 'blob'
    });
  }
}
